import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL } from '../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../assets/Messages.json'
import { Link, useNavigate } from 'react-router-dom';
import {showAppLoading,  generateYearRange, shortMonthToFull, getStatusFlagValue, validateButtonASIBlock, isHqAsiAdminRole } from '../../Custom/Custom';
import { validateFileForUpload } from '../../utils/fileValidation';
import asiTitle from '../../asi.json';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';

function parseApiDateToLocal(isoString) {
   if (!isoString) return null;
   const datePart = String(isoString).split('T')[0];
   const parts = datePart.split('-').map(Number);
   if (parts.length !== 3 || parts.some(isNaN)) return null;
   const [y, m, d] = parts;
   return new Date(y, m - 1, d);
}

export default function BlockM({
   blockPageInfo,
   config,
   userInfoObject,
   blockInfo,
   accessAsiBlock,
   decode_token
}) {


   const [years, setYears] = useState([]);
   const [months, setMonth] = useState([]);

   const [yearNameOfDateOfVerification, setYearNameOfDateOfVerification] = useState(new Date().getFullYear());
   const [startDateOfDateOfVerification, setStartDateOfDateOfVerification] = useState();

   const [yearNameOfDateOfScrutiny, setYearNameOfDateOfScrutiny] = useState(new Date().getFullYear());
   const [startDateOfDateOfScrutiny, setStartDateOfDateOfScrutiny] = useState();

   const [yearNameOfDateOfDespatch, setYearNameOfDateOfDespatch] = useState(new Date().getFullYear());
   const [startDateOfDateOfDespatch, setStartDateOfDateOfDespatch] = useState();

   const [signatureOfSuperintendingOfficer, setSignatureOfSuperintendingOfficer] = useState(null);
   const [signatureOfScrutinisingOfficer, setSignatureOfScrutinisingOfficer] = useState(null);

   const [nameOfSuperintendingOfficer, setNameOfSuperintendingOfficer] = useState('');
   const [designationOfDataEntryOfficer, setDesignationOfDataEntryOfficer] = useState('');
   const [nameAndDesignationOfScrutinisingOfficer, setNameAndDesignationOfScrutinisingOfficer] = useState('');
   const [designationOfScrutinisingOfficer, setDesignationOfScrutinisingOfficer] = useState('');

   const [blocMKData, setBlockMData] = useState({});
   //  const [dateOfReceiptFromFactory, setdateOfReceiptFromFactory] = useState('2024-10-02T00:00:00.000Z')
   const [yearNameOfDateOfReceiptFromFactory, setYearNameOfDateOfReceiptFromFactory] = useState(new Date().getFullYear());
   const [startDateOfDateOfReceiptFromFactory, setStartDateOfDateOfReceiptFromFactory] = useState(new Date());

   const [isDateOfReceipt, setIsDateOfReceipt] = useState(false);
   const [isDateOfVerification, setDateOfVerification] = useState(false);

   const [userNameError, setUserNameError] = useState("");
   const [designationNameError, setDesignationUserNameError] = useState("");
   const [designationOfDataEntryOfficerError, setDesignationOfDataEntryOfficerError] = useState("");
   const [designationOfScrutinisingOfficerError, setDesignationOfScrutinisingOfficerError] = useState("");

   const currentMonth = new Date().getMonth();
   const currentYear = new Date().getFullYear();
   const statusUnitCode = localStorage.getItem('statusUnitCode');
   const navigate = useNavigate();
   const yearRange = generateYearRange(blockInfo.surveyYear);
   const [buttonStatus, setButtonStatus] = useState('');
   const [statusFlageval, setstatusFlageval] = useState('');
   const userLevel = decode_token?.id?.USER_TYPE || '';
   const roleCodes = decode_token?.id?.ROLE_CODE
      ? String(decode_token.id.ROLE_CODE)
         .split('|')
         .map((r) => String(r).trim())
         .filter(Boolean)
      : [];
   const isDisasiDistrictUser =
      userLevel === 'DISTRICT LEVEL' && roleCodes.includes('DISASI');
   const isDivasiRole = roleCodes.includes('DISASI');
   const isDivasiRoleCode = roleCodes.includes('DIVASI');
   const isHqRole = roleCodes.includes('HQADM') || roleCodes.includes('HQASI');
   // Block M: HQADM/HQASI ke liye Save hamesha disable (status 3/7 pe bhi)
   const isHqSaveDisabled = isHqRole;
   const isDivasiStatusFlagOne = isDivasiRoleCode && String(statusFlageval ?? '').trim() === '1';
   const isRestrictedRoleWithEmptyStatusFlag = (isDivasiRoleCode || isHqRole) && String(statusFlageval ?? '').trim() === '';
   const isNextBlockAlreadyAccessible = (() => {
      const ids = JSON.parse(localStorage.getItem('blockIds') || '[]');
      return Array.isArray(ids) && ids.map(Number).includes(14);
   })();
   const isFactoFactoryUser =
      userLevel === 'FACTORY LEVEL' && roleCodes.includes('FACTO');
   const [filePath, setFilePath] = useState({
      pathSignatureOfSuperintendingOfficer: '',
      pathSignatureOfScrutinisingOfficer: ''
   });


   const handleInputUserName = (userName) => {
      // if(statusUnitCode !== '5'){
      if (userName.length >= 0 && userName.length <= 50) {
         setUserNameError("");
         return true;
      } else {
         setUserNameError("Maximum 50 characters allowed.");
         return false;
      }

      // }

   };


   const handleInputDesignationName = (userName) => {
      if (userName.length >= 0 && userName.length <= 50) {
         setDesignationUserNameError("");
         return true;
      } else {
         setDesignationUserNameError("Maximum 50 characters allowed.");
         return false;
      }
   };

   const DESIGNATION_MAX_LENGTH = 100;
   const DESIGNATION_REGEX = /^[a-zA-Z0-9\s.\-,()']*$/;

   const handleDesignationDataEntryOfficer = (value) => {
      if (!DESIGNATION_REGEX.test(value)) {
         setDesignationOfDataEntryOfficerError("Only letters, numbers, spaces and . - , ( ) ' are allowed.");
         return false;
      }
      if (value.length > DESIGNATION_MAX_LENGTH) {
         setDesignationOfDataEntryOfficerError(`Maximum ${DESIGNATION_MAX_LENGTH} characters allowed.`);
         return false;
      }
      setDesignationOfDataEntryOfficerError("");
      return true;
   };

   const handleDesignationScrutinisingOfficer = (value) => {
      if (!DESIGNATION_REGEX.test(value)) {
         setDesignationOfScrutinisingOfficerError("Only letters, numbers, spaces and . - , ( ) ' are allowed.");
         return false;
      }
      if (value.length > DESIGNATION_MAX_LENGTH) {
         setDesignationOfScrutinisingOfficerError(`Maximum ${DESIGNATION_MAX_LENGTH} characters allowed.`);
         return false;
      }
      setDesignationOfScrutinisingOfficerError("");
      return true;
   };

   const hnadleTextBoxOnChange = (e) => {
      const { name, value } = e.target;

      switch (name) {
         case 'Name_of_Superintending_Officer':
            if (!/^[a-zA-Z0-9\s]*$/.test(value)) return false;
            if (handleInputUserName(value)) {
               setNameOfSuperintendingOfficer(value)
            }
            break;
         case 'Designation_of_Data_Entry_Officer':
            if (!DESIGNATION_REGEX.test(value)) return false;
            if (handleDesignationDataEntryOfficer(value)) {
               setDesignationOfDataEntryOfficer(value);
            }
            break;
         case 'Designation_of_Scrutinising_Officer':
            if (!DESIGNATION_REGEX.test(value)) return false;
            if (handleDesignationScrutinisingOfficer(value)) {
               setDesignationOfScrutinisingOfficer(value);
            }
            break;
         case 'Name_and_Designationof_Scrutinising_Officer':
            if (handleInputDesignationName(value)) {
               setNameAndDesignationOfScrutinisingOfficer(value)
            }
            break;
      }
   }






   useEffect(() => {

      const getMonthsList = (e) => {
         showAppLoading(true)
         axios
            .get(`${API_URL}api/graph/getMonths/2019`, config)
            .then((res) => {
               let monthDataResponse = res.data;
               if (monthDataResponse.status) {
                  setMonth(monthDataResponse.data);
                  showAppLoading(false)
               }
            })
            .catch((err) => {
               console.error(err);
               showAppLoading(false);
            });
      }

      const getYearList = () => {
         const startYear = 2014; // Starting year
         const endYear = new Date().getFullYear(); // Current year (dynamic)

         const yearsArray = [];
         for (let year = startYear; year <= endYear; year++) {
            yearsArray.push(year);
         }

         setYears(yearsArray);
      };

      getYearList();
      getMonthsList();
      blockMAllData();
      // dateOfReceiptFromFactory() // Commented: API call removed, using current date directly

      // const userLevel = decode_token.id.USER_TYPE;
      // if(userLevel==='FACTORY LEVEL'){
      //    setIsDateOfReceipt(false)
      // }
      // console.log(userLevel)


   }, []);




   // Commented: API call removed, using current date directly for Date of receipt from factory
   // const dateOfReceiptFromFactory = async () => {
   //    const newObject = {
   //       dsl_no: blockInfo.dslNo
   //    };
   //    try {
   //       const response = await axios.post(`${API_URL}api/asi/AsiCreatedDateReceiptfactory`, newObject, config);
   //       const { data, status } = response.data;
   //       if (status && data.asiBlockMreceiptfactory && data.asiBlockMreceiptfactory[0]) {
   //          const reciptDate = data.asiBlockMreceiptfactory[0].CREATED_TIME;
   //          const statusFlagOfBlockL = data.asiBlockMreceiptfactory[0].STATUS_FLAG;
   //          if (["8", "6"].includes(statusFlagOfBlockL)) { //accept==8 and Reject==6
   //             setDateOfVerification(true)
   //             setStartDateOfDateOfVerification(new Date(reciptDate))
   //          } else {
   //             // Enable Date of verification/compilation field
   //             setDateOfVerification(false)
   //          }
   //          // Always set current date for Date of receipt from factory
   //          setStartDateOfDateOfReceiptFromFactory(new Date())
   //          setIsDateOfReceipt(true)
   //       } else {
   //          // If API doesn't return data, set current date
   //          setStartDateOfDateOfReceiptFromFactory(new Date())
   //          setIsDateOfReceipt(true)
   //       }
   //    } catch (error) {
   //       console.error(error);
   //       // On error, set current date
   //       setStartDateOfDateOfReceiptFromFactory(new Date())
   //       setIsDateOfReceipt(true)
   //       // Don't show error toast for this case as we're using current date as fallback
   //    }
   // }

   // Set current date directly for Date of receipt from factory
   useEffect(() => {
      setStartDateOfDateOfReceiptFromFactory(new Date());
      setIsDateOfReceipt(true);
   }, []);

   // Function to handle page load Form data
   const blockMAllData = async () => {
      const newObject = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      };
      try {
         const response = await axios.post(`${API_URL}api/asi/blockMForm`, newObject, config);
         const { data, status } = response.data;
         const responseBlockMData = data.asiBlockMdata[0];

         if (status && responseBlockMData) {

            const d = responseBlockMData;

            // Map all fields from API response (keys: name_dataEntry_officer, designation_dataEntry_officer, date_of_receipt_factory, etc.)
            setNameOfSuperintendingOfficer(d.name_dataEntry_officer ?? d.name_of_superintending_officer ?? '');
            setDesignationOfDataEntryOfficer(d.designation_dataEntry_officer ?? d.designation_of_data_entry_officer ?? '');
            setNameAndDesignationOfScrutinisingOfficer(d.name_scrutinising_officer ?? d.name_and_designation_of_scrutinising_officer ?? '');
            setDesignationOfScrutinisingOfficer(d.designation_scrutinising_officer ?? d.designation_of_scrutinising_officer ?? '');

            const parseDate = (val) => (val && val !== "0000-00-00" ? parseApiDateToLocal(val) : null);

            const receiptDate = parseDate(d.date_of_receipt_factory ?? d.date_of_receipt_from_factory);
            if (receiptDate) {
               setStartDateOfDateOfReceiptFromFactory(receiptDate);
               setIsDateOfReceipt(true);
            }


            const verificationDate = parseDate(d.date_of_verification_compilation);
            if (verificationDate) setStartDateOfDateOfVerification(verificationDate);
            const scrutinyDate = parseDate(d.dates_of_scrutiny);
            if (scrutinyDate) setStartDateOfDateOfScrutiny(scrutinyDate);
            const despatchDate = parseDate(d.date_of_despatch);
            if (despatchDate) setStartDateOfDateOfDespatch(despatchDate);

            setSignatureOfSuperintendingOfficer(d.signature_of_superintending_officer || null);
            setSignatureOfScrutinisingOfficer(d.signature_of_scrutinising_officer || null);
            setFilePath({
               pathSignatureOfSuperintendingOfficer: d.signature_of_superintending_officer
                  ? `${API_URL}uploads/${d.signature_of_superintending_officer}`
                  : '',
               pathSignatureOfScrutinisingOfficer: d.signature_of_scrutinising_officer
                  ? `${API_URL}uploads/${d.signature_of_scrutinising_officer}`
                  : ''
            });
         }

         // Button rights: Block A statusFlag is workflow source of truth (Block M row can be stale)
         let statusFlagVal = responseBlockMData?.statusFlag ?? responseBlockMData?.status_flag ?? '';
         try {
            const aRes = await axios.post(`${API_URL}api/asi/blockAForm`, newObject, config);
            const aFlag = aRes?.data?.data?.blockAData?.statusFlag;
            if (aFlag !== undefined && aFlag !== null && String(aFlag).trim() !== '') {
               statusFlagVal = aFlag;
            }
         } catch (_) { /* keep Block M flag */ }

         setstatusFlageval(String(statusFlagVal ?? ''));
         const IsButtonStatus = await validateButtonASIBlock(decode_token, statusFlagVal);
         setButtonStatus(IsButtonStatus);
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showAppLoading(false);
      }

   }



   const filterDate = (date) => {
      return date <= new Date(); // Disable dates after today
   };


   // Function to handle reset Form Data
   const handleReset = () => {
      setNameOfSuperintendingOfficer('')
      setDesignationOfDataEntryOfficer('')
      setDesignationOfScrutinisingOfficer('')
      setDesignationOfDataEntryOfficerError('')
      setDesignationOfScrutinisingOfficerError('')
      setNameAndDesignationOfScrutinisingOfficer('')
      setStartDateOfDateOfDespatch('')
      setStartDateOfDateOfScrutiny('')
      setStartDateOfDateOfVerification('')
      if (!isDateOfReceipt) { setStartDateOfDateOfReceiptFromFactory(''); }
      const Signature_of_Superintending_Officer = document.getElementById('Signature_of_Superintending_Officer');
      if (Signature_of_Superintending_Officer) {
         Signature_of_Superintending_Officer.value = '';
      }

      setSignatureOfSuperintendingOfficer(null);
      const Signature_of_Scrutinising_Officer = document.getElementById('Signature_of_Scrutinising_Officer');
      if (Signature_of_Scrutinising_Officer) {
         Signature_of_Scrutinising_Officer.value = '';
      }

      setSignatureOfScrutinisingOfficer(null);
   }




   // Function to handle file upload on change (MIME + extension + double-extension validated)
   const handleFileChange = (e) => {
      const name = e.target.name;
      const file = e.target.files[0];
      if (!file) return;

      const result = validateFileForUpload(file, ['.png', '.jpg', '.jpeg']);
      if (!result.valid) {
         toast.error(result.error, messages.COLOR_RED);
         e.target.value = '';
         return;
      }

      switch (name) {
         case 'Signature_of_Superintending_Officer':
            setSignatureOfSuperintendingOfficer(file);
            break;
         case 'Signature_of_Scrutinising_Officer':
            setSignatureOfScrutinisingOfficer(file);
            break;
         default:
            toast.error('Invalid file type', messages.COLOR_RED);
            e.target.value = '';
            break;
      }
   }


   // Function to handle going to the previous block
   const handlePrevious = () => {
      const confirmed = window.confirm("Have you saved your changes?");
      if (confirmed) {
         navigate("/BlockL")
      }
   }

   // Button enable/disable by statusFlag (same logic as BlockL)
   useEffect(() => {
      let duser = 0;
      if (userLevel === 'DIVISION LEVEL') {
         if (statusFlageval === "3" || statusFlageval === "7" || statusFlageval === "8")
            duser = 1;
      }
      if (statusFlageval === "4" || statusFlageval === "9") {
         const rejectBtn = document.getElementById("reject");
         if (rejectBtn) rejectBtn.disabled = true;
      }
      if (userLevel === 'HEAD QUARTER') {
         if (statusFlageval === "2" || statusFlageval === "6") duser = 1;
         if (statusFlageval === "3") duser = 2;
      }
      if (duser === 2 && userLevel === 'HEAD QUARTER') {
         if (!(statusFlageval === "3" && isHqAsiAdminRole(roleCodes))) {
            const saveBtn = document.getElementById("save");
            if (saveBtn) saveBtn.disabled = true;
         }
      }
      if (duser === 1) {
         const saveBtn = document.getElementById("save");
         if (saveBtn) saveBtn.disabled = true;
         if (userLevel === 'DIVISION LEVEL') {
            const submitBtn = document.getElementById("submit");
            if (submitBtn) submitBtn.disabled = true;
            const rejectBtnDiv = document.getElementById("reject");
            if (rejectBtnDiv) rejectBtnDiv.disabled = true;
         }
         if (userLevel === 'HEAD QUARTER') {
            const acceptBtn = document.getElementById("accept");
            const rejectBtn = document.getElementById("reject");
            if (acceptBtn) acceptBtn.disabled = true;
            if (rejectBtn) rejectBtn.disabled = true;
         }
      }

      // Block M: HQADM/HQASI → Save hamesha band
      if (isHqAsiAdminRole(roleCodes)) {
         const saveBtn = document.getElementById("save");
         if (saveBtn) saveBtn.disabled = true;
      }
   }, [userLevel, statusFlageval]);

   //All block validation Data
   const blockValidation = async () => {

      let postData = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      }
      

      try {
         showAppLoading(true);
         const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
         const { data, status } = response.data;
         const accessIds = data.allblockData
         if (accessIds.length > 0) {
            if (accessIds.length > [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].length) {
               accessAsiBlock(accessIds)
            } else {
               accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14])
            }
         } else {
            accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14])
         }
         showAppLoading(false);
         return true;

      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {

      }

   }




   // Function to handle going to the next block
   const handleNext = async () => {
         // Next unlocked + Save disabled → skip save, sirf navigate (DIVASI/FACTO/DISASI/HQ sab)
         if (isNextBlockAlreadyAccessible && (buttonStatus || isDivasiStatusFlagOne || isRestrictedRoleWithEmptyStatusFlag)) {
            navigate("/BlockN");
            return;
         }
         // DIVASI + statusFlag=1: do not save, just navigate
         if (isDivasiStatusFlagOne) {
            navigate("/BlockN");
            return;
         }
         const confirmed = window.confirm("Have you saved your changes?");
         if (!confirmed) return;
         if (statusUnitCode === '5') {

            const saveResult = await handleSaveData("SAVE");
            if (saveResult) {
               await blockValidation()
               navigate("/BlockN")
            }

         } else {
            const saveResult = await handleSaveData("SAVE");
            if (saveResult) {
               await blockValidation()
               navigate("/BlockN");
            }
         }
   }

   // (filePath.pathSignatureOfSuperintendingOfficer,signatureOfSuperintendingOfficer)
   // DownLoad file *************
   const downloadFile = async (url, filename) => {

      console.log(url);
      console.log(filename);
      console.log(typeof url);
      console.log(typeof filename);

      if (filename && url && filename !== null) {
         const link = document.createElement('a');
         link.href = url;
         link.download = filename;
         link.target = "_blank";
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
      } else {
         alert("Please Upload the Signature");
      }

   }


   // Form Validation 
   const validateForm = () => {
      if (!nameOfSuperintendingOfficer || String(nameOfSuperintendingOfficer).trim() === '') {
         toast.error('Please enter the Name of Data Entry Officer', messages.COLOR_RED);
         return false;
      }
      // Commented: Allow save without file upload
      // if (signatureOfSuperintendingOfficer === null) {//file validation
      //    toast.error('Please Upload the Signature of Superintending Officer', messages.COLOR_RED);
      //    return false;
      // }
      // Commented: Allow save without Name and Designation of Scrutinising Officer
      // if (nameAndDesignationOfScrutinisingOfficer === '') {
      //    toast.error('Please enter the Name and Designation of Scrutinising Officer', messages.COLOR_RED);
      //    return false;
      // }
      // Commented: Allow save without file upload
      if (designationOfDataEntryOfficer.length > DESIGNATION_MAX_LENGTH || !DESIGNATION_REGEX.test(designationOfDataEntryOfficer)) {
         toast.error('Please enter a valid Designation of Data Entry Officer (max 100 characters, only letters, numbers, spaces and . - , ( ) \' allowed).', messages.COLOR_RED);
         return false;
      }
      if (designationOfScrutinisingOfficer.length > DESIGNATION_MAX_LENGTH || !DESIGNATION_REGEX.test(designationOfScrutinisingOfficer)) {
         toast.error('Please enter a valid Designation of Scrutinising Officer (max 100 characters, only letters, numbers, spaces and . - , ( ) \' allowed).', messages.COLOR_RED);
         return false;
      }
      if (typeof startDateOfDateOfReceiptFromFactory === 'undefined' || startDateOfDateOfReceiptFromFactory === null) {
         toast.error('Please enter the Date of Receipt from Factory', messages.COLOR_RED);
         return false;
      }
      if (typeof startDateOfDateOfVerification === 'undefined' || startDateOfDateOfVerification === '') {
         toast.error('Please enter the Date of Verification/ Compilation', messages.COLOR_RED);
         return false;
      }
      if (typeof startDateOfDateOfScrutiny === 'undefined' || startDateOfDateOfScrutiny === '') {
         toast.error('Please enter the Date of Scrutiny', messages.COLOR_RED);
         return false;
      }
      if (typeof startDateOfDateOfDespatch === 'undefined' || startDateOfDateOfDespatch === '') {
         toast.error('Please enter the Date of Dispatch', messages.COLOR_RED);
         return false;
      }

      return true;
   };

   // FACTO + FACTORY: sirf SL 1, 2, 3 mandatory; baaki fields UI me disabled rehte hain
   const validateFactoFactoryMandatoryFields = () => {
      if (!nameOfSuperintendingOfficer || String(nameOfSuperintendingOfficer).trim() === '') {
         toast.error('Please enter the Name of Data Entry Officer', messages.COLOR_RED);
         return false;
      }
      if (!designationOfDataEntryOfficer || String(designationOfDataEntryOfficer).trim() === '') {
         toast.error('Please enter the Designation of Data Entry Officer', messages.COLOR_RED);
         return false;
      }
      if (
         designationOfDataEntryOfficer.length > DESIGNATION_MAX_LENGTH ||
         !DESIGNATION_REGEX.test(designationOfDataEntryOfficer)
      ) {
         toast.error(
            'Please enter a valid Designation of Data Entry Officer (max 100 characters, only letters, numbers, spaces and . - , ( ) \' allowed).',
            messages.COLOR_RED
         );
         return false;
      }
      if (
         typeof startDateOfDateOfReceiptFromFactory === 'undefined' ||
         startDateOfDateOfReceiptFromFactory === null ||
         startDateOfDateOfReceiptFromFactory === ''
      ) {
         toast.error('Please enter the Date of Receipt from Factory', messages.COLOR_RED);
         return false;
      }
      return true;
   };

   // DISASI + DISTRICT: SL 1,2,3 (receipt auto), 4 mandatory; 5–8 UI me disabled
   const validateDisasiDistrictMandatoryFields = () => {
      if (!nameOfSuperintendingOfficer || String(nameOfSuperintendingOfficer).trim() === '') {
         toast.error('Please enter the Name of Data Entry Officer', messages.COLOR_RED);
         return false;
      }
      if (!designationOfDataEntryOfficer || String(designationOfDataEntryOfficer).trim() === '') {
         toast.error('Please enter the Designation of Data Entry Officer', messages.COLOR_RED);
         return false;
      }
      if (
         designationOfDataEntryOfficer.length > DESIGNATION_MAX_LENGTH ||
         !DESIGNATION_REGEX.test(designationOfDataEntryOfficer)
      ) {
         toast.error(
            'Please enter a valid Designation of Data Entry Officer (max 100 characters, only letters, numbers, spaces and . - , ( ) \' allowed).',
            messages.COLOR_RED
         );
         return false;
      }
      if (
         typeof startDateOfDateOfReceiptFromFactory === 'undefined' ||
         startDateOfDateOfReceiptFromFactory === null ||
         startDateOfDateOfReceiptFromFactory === ''
      ) {
         toast.error('Please enter the Date of Receipt from Factory', messages.COLOR_RED);
         return false;
      }
      if (
         typeof startDateOfDateOfVerification === 'undefined' ||
         startDateOfDateOfVerification === '' ||
         startDateOfDateOfVerification === null
      ) {
         toast.error('Please enter the Date of Verification/ Compilation', messages.COLOR_RED);
         return false;
      }
      return true;
   };

   // DIVASI: SL 5 (Name) aur 6 (Designation) of Scrutinising Officer mandatory
   const validateDivasiMandatoryFields = () => {
      if (!nameAndDesignationOfScrutinisingOfficer || String(nameAndDesignationOfScrutinisingOfficer).trim() === '') {
         toast.error('Please enter the Name of Scrutinising Officer', messages.COLOR_RED);
         return false;
      }
      if (!designationOfScrutinisingOfficer || String(designationOfScrutinisingOfficer).trim() === '') {
         toast.error('Please enter the Designation of Scrutinising Officer', messages.COLOR_RED);
         return false;
      }
      return true;
   };



   // Function to handle update and save form data
   const handleSaveData = async (buttonType) => {
      if (isFactoFactoryUser) {
         if (!validateFactoFactoryMandatoryFields()) {
            return false;
         }
      } else if (isDisasiDistrictUser) {
         if (!validateDisasiDistrictMandatoryFields()) {
            return false;
         }
      } else {
         if (!nameOfSuperintendingOfficer || String(nameOfSuperintendingOfficer).trim() === '') {
            toast.error('Please enter the Name of Data Entry Officer.', messages.COLOR_RED);
            return false;
         }

         if (isDivasiRoleCode && !validateDivasiMandatoryFields()) {
            return false;
         }

         const shouldSkipValidation = ['4', '5', '7','8'].includes(statusUnitCode) && blockInfo.surveyYear == '2024';
         if (!shouldSkipValidation) {
            if (!validateForm()) {
               return false;
            }
         }
      }


      const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);

      const formatDate = (d) => (d ? format(new Date(d), 'yyyy-MM-dd') : '');

      const payload = {
         dslNo: blockInfo.dslNo ?? '',
         surveyYear: blockInfo.surveyYear ?? '',
         name_dataEntry_officer: nameOfSuperintendingOfficer ?? '',
         designation_dataEntry_officer: designationOfDataEntryOfficer ?? '',
         date_of_receipt_factory: formatDate(startDateOfDateOfReceiptFromFactory),
         date_of_verification_compilation: formatDate(startDateOfDateOfVerification),
         date_of_verification: formatDate(startDateOfDateOfVerification),
         name_scrutinising_officer: nameAndDesignationOfScrutinisingOfficer ?? '',
         designation_scrutinising_officer: designationOfScrutinisingOfficer ?? '',
         dates_of_scrutiny: formatDate(startDateOfDateOfScrutiny),
         date_of_despatch: formatDate(startDateOfDateOfDespatch),
         statusFlag: clickButtonStatusFlag ?? ''
      };

      const apiConfig = {
         ...config,
         headers: {
            ...config.headers,
            'Content-Type': 'application/json'
         }
      };

      showAppLoading(true);
      try {
         const response = await axios.post(`${API_URL}api/asi/blockMFormSaveToDB`, payload, apiConfig);
         console.log(response);
         const { status, message } = response.data;
         if (status) {
            blockValidation()
            toast.success(message, messages.COLOR_RED);
            return true;
         }
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showAppLoading(false);
      }

      return false;


   }





   const storedLanguage = localStorage.getItem('language');

   return (
      <div className="card-body">
         <h4 className="page_heading border-bottom-0">
            <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_M_TITLE : asiTitle.en.BLOCK_M_TITLE }} />
         </h4>



         <div className="row">
            <div className="col-12">
               <h6 className="fw-semibold">
                  {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{blockInfo.dslNo}</span>
                  {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
               </h6>
               <div className="table-responsive asi_block_table">
                  <table cellPadding="0" cellSpacing="0" id="" className="table table-bordered block_c_table">
                     <thead className="text-center">
                        <tr>
                           <th>{storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}</th>
                           <th>{storedLanguage === 'hi' ? `Particulars of field operations ${yearRange}` : `Particulars of field operations ${yearRange}`} </th>
                           <th></th>
                        </tr>
                     </thead>
                     <tbody>

                        <tr>
                           <td>
                              1
                           </td>
                           <td>
                              Name of Data Entry Officer
                           </td>
                           <td>
                              <input
                                 type="text"
                                 className="form-control"
                                 name="Name_of_Superintending_Officer"
                                 value={nameOfSuperintendingOfficer}
                                 onChange={(e) => (hnadleTextBoxOnChange(e))}
                                 onBlur={(e) => handleInputUserName(e.target.value)}
                                 disabled={buttonStatus}
                              />
                              {userNameError && <i style={{ color: 'red', fontSize: '12px' }}>{userNameError}</i>}
                           </td>
                        </tr>

                        <tr>
                           <td>
                              2
                           </td>
                           <td>
                              Designation of Data Entry Officer
                           </td>
                           <td>
                              <input
                                 type="text"
                                 className="form-control"
                                 name="Designation_of_Data_Entry_Officer"
                                 value={designationOfDataEntryOfficer}
                                 onChange={(e) => hnadleTextBoxOnChange(e)}
                                 onBlur={(e) => handleDesignationDataEntryOfficer(e.target.value)}
                                 disabled={buttonStatus}
                              />
                              {designationOfDataEntryOfficerError && <i style={{ color: 'red', fontSize: '12px' }}>{designationOfDataEntryOfficerError}</i>}
                           </td>
                        </tr>


                        <tr>
                           <td>
                              3
                           </td>
                           <td>
                              Date of data receipt from factory
                           </td>
                           <td>
                              <DatePicker
                                 disabled={isDateOfReceipt || buttonStatus || isDisasiDistrictUser}
                                 className="form-control calendar_icon"
                                 dateFormat="dd-MM-yyyy"
                                 placeholderText="DD-MM-YYYY"
                                 selected={startDateOfDateOfReceiptFromFactory}
                                 onChange={(date) => {
                                    if (isDisasiDistrictUser) return;
                                    setStartDateOfDateOfReceiptFromFactory(date);
                                    //   setDateSelectedError(false);
                                 }}
                                 filterDate={filterDate}
                                 renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                                    <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
                                       <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                          {"<"}
                                       </button>
                                       <select
                                          onChange={(e) => {
                                             setYearNameOfDateOfReceiptFromFactory(parseInt(e.target.value));
                                             changeYear(parseInt(e.target.value));
                                          }}
                                          value={yearNameOfDateOfReceiptFromFactory} // Update value to yearName
                                       >
                                          <option value="" disabled>Select Year</option>
                                          {years &&
                                             years.map((ele, index) => (
                                                <option key={index} value={ele}>
                                                   {ele}
                                                </option>
                                             ))}
                                       </select>

                                       <select
                                          value={date.getMonth()}
                                          onChange={(e) => {
                                             //   setMonthName(e.target.value);
                                             changeMonth(e.target.value);
                                          }}
                                       >
                                          <option value="" disabled>Select Month</option>
                                          {months &&
                                             months
                                                .filter((_, i) => !(currentYear === yearNameOfDateOfReceiptFromFactory && i > currentMonth))
                                                .map((ele, i) => (
                                                   <option key={i} value={i}>
                                                      {shortMonthToFull(ele.MONTH)}
                                                   </option>
                                                ))}
                                       </select>

                                       <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                          {">"}
                                       </button>
                                    </div>
                                 )}
                              />

                           </td>
                        </tr>


                        <tr>
                           <td>
                              4
                           </td>
                           <td>
                              Date of verification/compilation
                           </td>
                           <td>

                              <DatePicker
                                 disabled={isDateOfVerification || isFactoFactoryUser || buttonStatus}
                                 className="form-control calendar_icon"
                                 dateFormat="dd-MM-yyyy"
                                 placeholderText="DD-MM-YYYY"
                                 selected={startDateOfDateOfVerification}
                                 onChange={(date) => {
                                    if (date && startDateOfDateOfReceiptFromFactory) {
                                       const verificationDate = new Date(date);
                                       const receiptDate = new Date(startDateOfDateOfReceiptFromFactory);
                                       verificationDate.setHours(0, 0, 0, 0);
                                       receiptDate.setHours(0, 0, 0, 0);
                                       
                                       if (verificationDate < receiptDate) {
                                          toast.error('Date of verification/compilation cannot be before Date of receipt from factory.', messages.COLOR_RED);
                                          return;
                                       }
                                    }
                                    setStartDateOfDateOfVerification(date);
                                 }}
                                 minDate={startDateOfDateOfReceiptFromFactory || null}
                                 maxDate={new Date()}
                                 filterDate={filterDate}
                                 key={startDateOfDateOfReceiptFromFactory ? startDateOfDateOfReceiptFromFactory.getTime() : 'no-receipt-date'}
                                 renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                                    <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
                                       <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                          {"<"}
                                       </button>
                                       <select
                                          onChange={(e) => {
                                             setYearNameOfDateOfVerification(parseInt(e.target.value));
                                             changeYear(parseInt(e.target.value));
                                          }}
                                          value={yearNameOfDateOfVerification}
                                       >
                                          <option value="" disabled>Select Year</option>
                                          {years &&
                                             years.map((ele, index) => (
                                                <option key={index} value={ele}>
                                                   {ele}
                                                </option>
                                             ))}
                                       </select>

                                       <select
                                          value={date.getMonth()}
                                          onChange={(e) => {
                                             changeMonth(e.target.value);
                                          }}
                                       >
                                          <option value="" disabled>Select Month</option>
                                          {months &&
                                             months
                                                .filter((_, i) => !(currentYear === yearNameOfDateOfVerification && i > currentMonth))
                                                .map((ele, i) => (
                                                   <option key={i} value={i}>
                                                      {shortMonthToFull(ele.MONTH)}
                                                   </option>
                                                ))}
                                       </select>

                                       <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                          {">"}
                                       </button>
                                    </div>
                                 )}
                              />
                           </td>
                        </tr>

                        <tr>
                           <td>
                              5
                           </td>
                           <td>
                              Name of Scrutinising Officer
                           </td>
                           <td>
                              <input
                                 type="text"
                                 className="form-control"
                                 name="Name_and_Designationof_Scrutinising_Officer"
                                 value={nameAndDesignationOfScrutinisingOfficer}
                                 onChange={(e) => (hnadleTextBoxOnChange(e))}
                                 onBlur={(e) => handleInputDesignationName(e.target.value)}
                                 disabled={isFactoFactoryUser || isDisasiDistrictUser || buttonStatus}
                              />
                              {designationNameError && <i style={{ color: 'red', fontSize: '12px' }}>{designationNameError}</i>}
                           </td>
                        </tr>

                        <tr>
                           <td>
                              6
                           </td>
                           <td>
                              Designation of Scrutinising Officer
                           </td>
                           <td>
                              <input
                                 type="text"
                                 className="form-control"
                                 name="Designation_of_Scrutinising_Officer"
                                 value={designationOfScrutinisingOfficer}
                                 onChange={(e) => hnadleTextBoxOnChange(e)}
                                 onBlur={(e) => handleDesignationScrutinisingOfficer(e.target.value)}
                                 disabled={isFactoFactoryUser || isDisasiDistrictUser || buttonStatus}
                              />
                              {designationOfScrutinisingOfficerError && <i style={{ color: 'red', fontSize: '12px' }}>{designationOfScrutinisingOfficerError}</i>}
                           </td>
                        </tr>

                        {/* <tr>
                           <td>
                              5
                           </td>
                           <td>
                              Date of receipt from factory
                           </td>
                           <td>
                              <DatePicker
                                 disabled={isDateOfReceipt}
                                 className="form-control calendar_icon"
                                 dateFormat="dd-MM-yyyy"
                                 placeholderText="DD-MM-YYYY"
                                 selected={startDateOfDateOfReceiptFromFactory}
                                 onChange={(date) => {
                                    setStartDateOfDateOfReceiptFromFactory(date);
                                 }}
                                 filterDate={filterDate}
                                 renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                                    <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
                                       <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                          {"<"}
                                       </button>
                                       <select
                                          onChange={(e) => {
                                             setYearNameOfDateOfReceiptFromFactory(parseInt(e.target.value));
                                             changeYear(parseInt(e.target.value));
                                          }}
                                          value={yearNameOfDateOfReceiptFromFactory} 
                                       >
                                          <option value="" disabled>Select Year</option>
                                          {years &&
                                             years.map((ele, index) => (
                                                <option key={index} value={ele}>
                                                   {ele}
                                                </option>
                                             ))}
                                       </select>

                                       <select
                                          value={date.getMonth()}
                                          onChange={(e) => {
                                             changeMonth(e.target.value);
                                          }}
                                       >
                                          <option value="" disabled>Select Month</option>
                                          {months &&
                                             months
                                                .filter((_, i) => !(currentYear === yearNameOfDateOfReceiptFromFactory && i > currentMonth))
                                                .map((ele, i) => (
                                                   <option key={i} value={i}>
                                                      {shortMonthToFull(ele.MONTH)}
                                                   </option>
                                                ))}
                                       </select>

                                       <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                          {">"}
                                       </button>
                                    </div>
                                 )}
                              />

                           </td>
                        </tr> */}

                        {/* <tr>
                           <td>
                              6
                           </td>
                           <td>
                              Date of verification/compilation
                           </td>
                           <td>

                              <DatePicker
                                 disabled={isDateOfVerification}
                                 className="form-control calendar_icon"
                                 dateFormat="dd-MM-yyyy"
                                 placeholderText="DD-MM-YYYY"
                                 selected={startDateOfDateOfVerification}
                                 onChange={(date) => {
                                    if (date && startDateOfDateOfReceiptFromFactory) {
                                       const verificationDate = new Date(date);
                                       const receiptDate = new Date(startDateOfDateOfReceiptFromFactory);
                                       verificationDate.setHours(0, 0, 0, 0);
                                       receiptDate.setHours(0, 0, 0, 0);
                                       
                                       if (verificationDate < receiptDate) {
                                          toast.error('Date of verification/compilation cannot be before Date of receipt from factory.', messages.COLOR_RED);
                                          return;
                                       }
                                    }
                                    setStartDateOfDateOfVerification(date);
                                 }}
                                 minDate={startDateOfDateOfReceiptFromFactory || null}
                                 maxDate={new Date()}
                                 filterDate={filterDate}
                                 key={startDateOfDateOfReceiptFromFactory ? startDateOfDateOfReceiptFromFactory.getTime() : 'no-receipt-date'}
                                 renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                                    <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
                                       <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                          {"<"}
                                       </button>
                                       <select
                                          onChange={(e) => {
                                             setYearNameOfDateOfVerification(parseInt(e.target.value));
                                             changeYear(parseInt(e.target.value));
                                          }}
                                          value={yearNameOfDateOfVerification}
                                       >
                                          <option value="" disabled>Select Year</option>
                                          {years &&
                                             years.map((ele, index) => (
                                                <option key={index} value={ele}>
                                                   {ele}
                                                </option>
                                             ))}
                                       </select>

                                       <select
                                          value={date.getMonth()}
                                          onChange={(e) => {
                                             changeMonth(e.target.value);
                                          }}
                                       >
                                          <option value="" disabled>Select Month</option>
                                          {months &&
                                             months
                                                .filter((_, i) => !(currentYear === yearNameOfDateOfVerification && i > currentMonth))
                                                .map((ele, i) => (
                                                   <option key={i} value={i}>
                                                      {shortMonthToFull(ele.MONTH)}
                                                   </option>
                                                ))}
                                       </select>

                                       <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                          {">"}
                                       </button>
                                    </div>
                                 )}
                              />
                           </td>
                        </tr> */}


                        <tr>
                           <td>
                              7
                           </td>
                           <td>
                              Date(s) of scrutiny
                           </td>

                           <td>
                              <DatePicker
                                 disabled={isFactoFactoryUser || isDisasiDistrictUser || buttonStatus}
                                 className="form-control calendar_icon"
                                 dateFormat="dd-MM-yyyy"
                                 placeholderText="DD-MM-YYYY"
                                 selected={startDateOfDateOfScrutiny}
                                 openToDate={startDateOfDateOfScrutiny || new Date()}
                                 onChange={(date) => {
                                    if (isFactoFactoryUser || isDisasiDistrictUser || buttonStatus) return;
                                    // Validate that scrutiny date is not before verification/compilation date
                                    if (date && startDateOfDateOfVerification && new Date(date) < new Date(startDateOfDateOfVerification)) {
                                       toast.error('Date(s) of scrutiny cannot be before Date of verification/compilation.', messages.COLOR_RED);
                                       return; // Prevent setting the invalid date
                                    }
                                    setStartDateOfDateOfScrutiny(date);
                                    if (date) {
                                       setYearNameOfDateOfScrutiny(date.getFullYear());
                                    }
                                    // If dispatch date is before the new scrutiny date, clear it
                                    if (startDateOfDateOfDespatch && date && new Date(startDateOfDateOfDespatch) < new Date(date)) {
                                       setStartDateOfDateOfDespatch(null);
                                       toast.error('Date of dispatch cannot be before Date(s) of scrutiny. Please select a new date.', messages.COLOR_RED);
                                    }
                                    //   setDateSelectedError(false);
                                 }}
                                 minDate={startDateOfDateOfVerification || null}
                                 filterDate={filterDate}
                                 key={startDateOfDateOfVerification ? startDateOfDateOfVerification.getTime() : 'no-verification-date'}
                                 renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                    // Always show current year in dropdown when calendar opens
                                    const currentYear = new Date().getFullYear();
                                    // Use selected date's year if date is selected and valid, otherwise use current year
                                    const selectedYear = startDateOfDateOfScrutiny && 
                                                         startDateOfDateOfScrutiny instanceof Date && 
                                                         !isNaN(startDateOfDateOfScrutiny.getTime())
                                                         ? startDateOfDateOfScrutiny.getFullYear() 
                                                         : currentYear;
                                    
                                    // Force calendar view to current year or selected year if it's showing old year
                                    const calendarViewYear = date.getFullYear();
                                    if (calendarViewYear !== selectedYear && calendarViewYear < currentYear) {
                                       // Only update if calendar is showing an old year
                                       changeYear(selectedYear);
                                    }
                                    
                                    // Update year state to ensure dropdown shows correct year
                                    if (yearNameOfDateOfScrutiny !== selectedYear) {
                                       setYearNameOfDateOfScrutiny(selectedYear);
                                    }
                                    
                                    return (
                                    <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
                                       <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                          {"<"}
                                       </button>
                                       <select
                                          onChange={(e) => {
                                             const selectedYearValue = parseInt(e.target.value);
                                             setYearNameOfDateOfScrutiny(selectedYearValue);
                                             changeYear(selectedYearValue);
                                          }}
                                          value={selectedYear} // Always show current year or selected date's year
                                       >
                                          <option value="" disabled>Select Year</option>
                                          {years &&
                                             years.map((ele, index) => (
                                                <option key={index} value={ele}>
                                                   {ele}
                                                </option>
                                             ))}
                                       </select>

                                       <select
                                          value={date.getMonth()}
                                          onChange={(e) => {
                                             //   setMonthName(e.target.value);
                                             changeMonth(e.target.value);
                                          }}
                                       >
                                          <option value="" disabled>Select Month</option>
                                          {months &&
                                             months
                                                .filter((_, i) => !(currentYear === yearNameOfDateOfScrutiny && i > currentMonth))
                                                .map((ele, i) => (
                                                   <option key={i} value={i}>
                                                      {shortMonthToFull(ele.MONTH)}
                                                   </option>
                                                ))}
                                       </select>

                                       <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                          {">"}
                                       </button>
                                    </div>
                                    )
                                 }}
                              />
                           </td>
                        </tr>

                        <tr>
                           <td>
                              8
                           </td>
                           <td>
                              Date of dispatch
                           </td>
                           <td>
                              <DatePicker
                                 disabled={isFactoFactoryUser || isDisasiDistrictUser || buttonStatus}
                                 className="form-control calendar_icon"
                                 dateFormat="dd-MM-yyyy"
                                 placeholderText="DD-MM-YYYY"
                                 selected={startDateOfDateOfDespatch}
                                 onChange={(date) => {
                                    // Validate that dispatch date is not before scrutiny date
                                    if (date && startDateOfDateOfScrutiny && new Date(date) < new Date(startDateOfDateOfScrutiny)) {
                                       toast.error('Date of dispatch cannot be before Date(s) of scrutiny.', messages.COLOR_RED);
                                       return;
                                    }
                                    setStartDateOfDateOfDespatch(date);
                                    //   setDateSelectedError(false);
                                 }}
                                 minDate={startDateOfDateOfScrutiny || null}
                                 filterDate={filterDate}
                                 key={startDateOfDateOfScrutiny ? startDateOfDateOfScrutiny.getTime() : 'no-scrutiny-date'}
                                 renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                                    <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
                                       <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                          {"<"}
                                       </button>
                                       <select
                                          onChange={(e) => {
                                             setYearNameOfDateOfDespatch(parseInt(e.target.value));
                                             changeYear(parseInt(e.target.value));
                                          }}
                                          value={yearNameOfDateOfDespatch} // Update value to yearName
                                       >
                                          <option value="" disabled>Select Year</option>
                                          {years &&
                                             years.map((ele, index) => (
                                                <option key={index} value={ele}>
                                                   {ele}
                                                </option>
                                             ))}
                                       </select>

                                       <select
                                          value={date.getMonth()}
                                          onChange={(e) => {
                                             //   setMonthName(e.target.value);
                                             changeMonth(e.target.value);
                                          }}
                                       >
                                          <option value="" disabled>Select Month</option>
                                          {months &&
                                             months
                                                .filter((_, i) => !(currentYear === yearNameOfDateOfDespatch && i > currentMonth))
                                                .map((ele, i) => (
                                                   <option key={i} value={i}>
                                                      {shortMonthToFull(ele.MONTH)}
                                                   </option>
                                                ))}
                                       </select>

                                       <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                          {">"}
                                       </button>
                                    </div>
                                 )}
                              />
                           </td>
                        </tr>


                     </tbody>
                  </table>
               </div>
            </div>
         </div>
         <div className="row">
            <div className="col-12">
               <hr />
            </div>

            <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
               <button
                  type="submit"
                  className="btn btn_orange me-1"
                  onClick={() => { window.print() }}
               >Print
                  <i className="fa fa-print ms-1"></i>
               </button>

               <button
                  type="button"
                  id="save"
                  className="btn btn_orange me-1"
                  onClick={(e) => { handleSaveData("SAVE") }}
                  disabled={buttonStatus || isHqSaveDisabled || isRestrictedRoleWithEmptyStatusFlag}
               >
                  Save
               </button>

               <button
                  type="reset"
                  className="btn btn_orange me-1"
                  onClick={handleReset}
               >
                  Reset
               </button>

               <button
                  type="button"
                  className="btn btn_orange"
                  onClick={(e) => (navigate("/dashboard"))}
               >
                  Cancel
               </button>

            </div>

            <div className="col-lg-4 text-center text-lg-end">
               <button
                  type="button"
                  className="btn btn_orange mx-1"
                  onClick={handlePrevious}
               >
                  <i className="fa fa-angle-left me-1"></i>
                  Previous
               </button>

               <button
                  type="button"
                  className="btn btn_orange mx-1"
                  onClick={handleNext}
                  disabled={isNextBlockAlreadyAccessible ? false : (isRestrictedRoleWithEmptyStatusFlag ? true : (isDivasiStatusFlagOne ? false : buttonStatus))}
               >
                  Next
                  <i className="fa fa-angle-right ms-1"></i>
               </button>

            </div>

         </div>
      </div>
   )
}